<template>
<div class="px-2 mt-2 mb-3">
    <div class="col-md-12 table-responsive" id="div-tabla-anular">
        <table id="tb-anular" class="table table-bordered">
            <thead class="bg-main">
                <tr class="text-white text-center text-xs">
                    <th scope="col" class="align-middle">
                       N°
                    </th>
                    <th scope="col" class="align-middle">
                        CATEGORIA
                    </th>
                    <th scope="col" class="align-middle">
                        SUBCATEGORIA
                    </th>
                    <th scope="col" class="align-middle">
                        NOMBRE
                    </th>
                </tr>
            </thead>

            <tbody class="border-main">
                <tr class="tbody-table align-middle text-xs" v-for="(producto, index) in cpData" :key="index">
                    <td class="clickCarrito" @click="mtdAddItemCarrito(producto)">
                        {{mtdNumber(index)}}
                    </td>
                    <td class="clickCarrito" @click="mtdAddItemCarrito(producto)">
                        {{ producto.cat_name ? producto.cat_name : '-' }}
                    </td>
                    <td>
                        {{ producto.sub_name ? producto.sub_name : '-' }}
                    </td>
                    <td>
                        {{ producto.name }}
                    </td>
                </tr>
                <tr v-if="!cpData.length > 0" class="text-center text-xs">
                    <th scope="col" colspan="6">NO SE ENCONTRARON RESULTADOS</th>
                </tr>
            </tbody>
        </table>
    </div>
    <div class="d-flex justify-content-center" style="align-items: center">
        <nav v-if="cpData.length > 0" aria-label="Page navigation example">
            <ul class="pagination">
                <li class="page-item">
                    <a class="anterior-siguiente page-link page" href="javascript:void(0)" @click="backPage">Anterior</a>
                </li>
                <li v-if="limitedStepPagination[0] !== 1" class="page-item">
                    <a class="page-link page" href="javascript:void(0)" @click="selectedPage(1)">1</a>
                </li>
                <li v-if="limitedStepPagination[0] > 2" class="page-item disabled">
                    <span class="page-link">...</span>
                </li>
                <li v-for="(item, index) in limitedStepPagination" :key="index" class="page-item">
                    <a :class="selectPage === item ? 'page-link active' : 'page-link'" href="javascript:void(0)" @click="selectedPage(item)">{{ item }}</a>
                </li>
                <li v-if="
              limitedStepPagination[limitedStepPagination.length - 1] <
              stepPagination.length - 1
            " class="page-item disabled">
                    <span class="page-link">...</span>
                </li>
                <li v-if="
              limitedStepPagination[limitedStepPagination.length - 1] !==
              stepPagination.length
            " class="page-item">
                    <a class="page-link page" href="javascript:void(0)" @click="selectedPage(stepPagination.length)">{{ stepPagination.length }}</a>
                </li>
                <li class="page-item">
                    <a class="anterior-siguiente page-link page" href="javascript:void(0)" @click="nextPage">Siguiente</a>
                </li>
            </ul>
        </nav>
    </div>
</div>
</template>

<script>
import {mapActions} from "vuex";

export default {
    name: "ViewActivos",
    components: {},
    data() {
        return {
            dataShow: [],
            search: "",
            //Pag
            page: 0,
            selectPage: 1,
            stepPagination: [],
            totalPagesToShow: 7,
        };
    },
    computed: {
        cpData() {
            let filteredData = this.actives;
            let totalPages = Math.ceil(filteredData.length / 10);
            this.stepPagination = Array.from({
                    length: totalPages,
                },
                (_, index) => index + 1
            );
            let startIndex = (this.selectPage - 1) * 10;
            let endIndex = startIndex + 9;
            this.dataShow = filteredData.slice(startIndex, endIndex + 1);
            return this.dataShow;
        },
        limitedStepPagination() {
            const totalPages = this.stepPagination.length;
            const currentPage = this.selectPage;
            let startPage = 1;
            let endPage = totalPages;
            if (totalPages > this.totalPagesToShow) {
                const halfPagesToShow = Math.floor(this.totalPagesToShow / 2);

                if (currentPage > halfPagesToShow) {
                    startPage = currentPage - halfPagesToShow;
                    endPage = currentPage + halfPagesToShow - 1;

                    if (endPage > totalPages) {
                        endPage = totalPages;
                        startPage = totalPages - this.totalPagesToShow + 1;
                    }
                } else {
                    endPage = this.totalPagesToShow;
                }
            }

            return Array.from({
                    length: endPage - startPage + 1,
                },
                (_, i) => startPage + i
            );
        },
    },
    props: {
        actives: {
            type: Array,
            default: () => [],
        },
    },

    created() {
        this.mtdGetData();
    },
    methods: {
        ...mapActions(["get", "post"]),

        mtdGetData: function () {
            /** paginación */
            let cantidad = parseInt(this.actives.length / 20);
            let residuo = parseInt(this.actives.length % 20);
            cantidad = residuo > 0 ? cantidad + 1 : cantidad;
            for (let index = 0; index < cantidad; index++) {
                this.stepPagination.push(index + 1);
            }
        },

        /** metodos carrito */
        mtdAddItemCarrito: function (payload) {
            this.clear();
            this.$emit("mtdAddItemCarrito", payload);
        },

        clear: function () {
            this.dataShow = [],
            this.search = "",
            this.page = 0,
            this.selectPage = 1,
            this.stepPagination = [],
            this.totalPagesToShow = 7
        },
        
        /** pagination */
        backPage() {
            this.selectPage = this.selectPage > 1 ? this.selectPage - 1 : 1;
        },
        nextPage() {
            this.selectPage =
                this.selectPage < this.stepPagination.length ?
                this.selectPage + 1 :
                this.stepPagination.length;
        },
        selectedPage(page) {
            this.selectPage = page;
        },
        mtdNumber: function(index){
            return (this.selectPage-1)*10 + (index + 1)
        },
    },
};
</script>

<style scoped>
#input-cantidad:focus-within input {
    border: none;
    outline: none;
    box-shadow: none;
}

#input-cantidad:hover {
    border: solid 1px #43517A;
}

.bg-color1 {
    background-color: #D5DBDB;
}

.bg-color2 {
    background-color: #BFC9CA;
}

@media (max-width: 1200px) {
    .responsive-proveedor {
        flex-direction: column;
    }

    .responsive-contador {
        flex-direction: column;
    }

    .responsive-contador {
        margin-top: 10px;
        width: 100% !important;
    }
}

@media (max-width: 536px) {
    .responsive-default {
        flex-direction: column;
    }

    .responsive-default>.py-1 {
        margin-top: 5px;
        margin-bottom: 5px;
        border-radius: 0px;
    }

    .responsive-default-div {
        border-radius: 10px !important;
        text-align: center !important;
        font-size: 11px;
    }
}

.anterior-siguiente:focus {
    background: #43517A;
}

.anterior-siguiente:hover {
    background: #bb026c;
}

.btn-ver:focus {
    background: #43517A;
}

.btn-ver:hover {
    background: #bb026c;
}

.clickCarrito {
    cursor: pointer;
}

.clickCarrito:hover {
    background-color: #F4AEC1;

}
</style>
